import type { ProgramTemplate } from '../types/templates';

export const mockProgramTemplates: ProgramTemplate[] = [
  {
    id: 'tmpl_full_body_starter',
    name: 'Full-Body Starter',
    totalWeeks: 8,
    source: 'mock',
    pattern: [
      { weekday: 0, type: 'rest', title: 'Rest' },
      { weekday: 1, type: 'strength', title: 'Lower Body Strength', durationMin: 45, meals: 4 },
      { weekday: 2, type: 'cardio', title: 'Zone 2 Cardio', durationMin: 35, meals: 4 },
      { weekday: 3, type: 'strength', title: 'Upper Body Strength', durationMin: 50, meals: 4 },
      { weekday: 4, type: 'mobility', title: 'Mobility + Core', durationMin: 25, meals: 4 },
      { weekday: 5, type: 'strength', title: 'Full-Body Strength', durationMin: 55, meals: 4 },
      { weekday: 6, type: 'cardio', title: 'Interval Run', durationMin: 30, meals: 4 },
    ],
  },
  {
    id: 'tmpl_cutting_phase',
    name: 'Cutting Phase (S&C)',
    totalWeeks: 12,
    source: 'mock',
    pattern: [
      { weekday: 0, type: 'rest', title: 'Rest' },
      { weekday: 1, type: 'strength', title: 'Heavy Lower', durationMin: 50, meals: 4 },
      { weekday: 2, type: 'hiit', title: 'HIIT Sprints', durationMin: 28, meals: 4 },
      { weekday: 3, type: 'strength', title: 'Heavy Upper', durationMin: 55, meals: 4 },
      { weekday: 4, type: 'recovery', title: 'Recovery + Mobility', durationMin: 25, meals: 4 },
      { weekday: 5, type: 'strength', title: 'Volume Full-Body', durationMin: 60, meals: 4 },
      { weekday: 6, type: 'cardio', title: 'Tempo Run', durationMin: 40, meals: 4 },
    ],
  },
];
